"use client";

import { useParams, useRouter, useSearchParams } from "next/navigation";
import { Suspense, useTransition } from "react";

function Select({ paramName, isFrom, children }: { paramName: string; isFrom: boolean; children: React.ReactNode }) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [isPending, startTransition] = useTransition();

  const val = searchParams.get(paramName);
  const isSelect = val && (isFrom ? val.substring(0, 2) !== "15" : val.substring(3, 4) !== "50");

  const handleUrl = (e: React.ChangeEvent<HTMLSelectElement>) => {
    startTransition(() => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(paramName, String(e.target.value));
      router.replace("?" + params.toString(), { scroll: false });
    });
  };

  return (
    <select
      className={`${isSelect ? "select-accent" : "select-secondary"} ${
        isPending && "skeleton rounded-md bg-gray-500"
      } select select-sm w-full max-w-xs`}
      value={val || ""}
      onChange={handleUrl}
      aria-label={paramName}
    >
      {children}
    </select>
  );
}

export function Filter({ paramName }: { paramName: string }) {
  const { year } = useParams();
  const searchParams = useSearchParams();
  const age = searchParams.get(paramName);
  const fromAge = age?.substring(0, 2) ?? "15";
  const toAge = age?.substring(2, 4) ?? "50";

  const rangeOptions = (isFrom: boolean) =>
    [...Array(35)].map((_, i) => {
      const val = 15 + i + Number(!isFrom);
      const name = `${val}歳（${String(Number(year) - 1 - val)?.substring(2)}年）`;
      return { val: isFrom ? val + toAge : fromAge + val, name };
    });

  return (
    <label className="flex items-center text-nowrap">
      <Select paramName={paramName} isFrom={true}>
        <option value="" disabled>
          年齢下限
        </option>
        {rangeOptions(true).map((m) => (
          <option key={m.name} value={m.val}>
            {m.name}
          </option>
        ))}
      </Select>
      <span className="mx-2">~</span>
      <Select paramName={paramName} isFrom={false}>
        <option value="" disabled>
          年齢上限
        </option>
        {rangeOptions(false).map((m) => (
          <option key={m.name} value={m.val}>
            {m.name}
          </option>
        ))}
      </Select>
    </label>
  );
}

export function AgeFilter({ paramName }: { paramName: string }) {
  return (
    <Suspense fallback={<></>}>
      <Filter paramName={paramName} />
    </Suspense>
  );
}
